<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/borrower/pixinvent
========================================================================================== -->


<template>
  <div>
    <vx-card>
      <vs-table pagination max-items="10" search :data="_borrowers">

        <template slot="thead">
          <vs-th>โครงการ</vs-th>
          <vs-th>เลขที่บัตรประชาชน</vs-th>
          <vs-th>รหัสนักศึกษา</vs-th>
          <vs-th>ชื่อ-นามสกุล</vs-th>
          <vs-th>เวลา</vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="index" v-for="(row, index) in data">
            <vs-td>
              {{ row.projectName }}
            </vs-td>
            <vs-td>
              {{ row.idCardNumber }}
            </vs-td>
            <vs-td>
              {{ row.studentCode }}
            </vs-td>
            <vs-td>
              {{row.fullName }}
            </vs-td>
            <vs-td>
              {{row.createdAt }}
            </vs-td>
            <vs-td>
              <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                <vx-tooltip text="ดูข้อมูล">
                  <vs-button class="p-5" color="success" type="flat" icon-pack="feather" icon="icon-eye" @click="view(row.id)"></vs-button>
                </vx-tooltip>
                <vx-tooltip text="แก้ไขข้อมูล">
                  <vs-button class="p-5" color="warning" type="flat" icon-pack="feather" icon="icon-edit" @click="edit(row.id)"></vs-button>
                </vx-tooltip>
                <vx-tooltip text="อนุมัติข้อมูล">
                  <vs-button class="p-5" color="success" type="flat" icon-pack="feather" icon="icon-check-square" @click="approved(row.id)"></vs-button>
                </vx-tooltip>
                <vx-tooltip text="ลบข้อมูล">
                  <vs-button class="p-5" color="danger" type="flat" icon-pack="feather" icon="icon-trash" @click="del(row.id)"></vs-button>
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const {mapActions: mapCustomerActions, mapState: mapCustomerFields } = createNamespacedHelpers('Customer')

export default {
  name: 'ExternalBorrowerUnApproved',
  async created() {
    await this.getBorrowersIsUnApproved();
  },
  computed: {
    ...mapCustomerFields([
      'borrowersIsUnApproved',
      'status'
    ]),
    _borrowers() {
      if(this.borrowersIsUnApproved){
        return this.borrowersIsUnApproved;
      }
    }
  },
  methods: {
    ...mapCustomerActions(['getBorrowersIsUnApproved', 'approvedExternalBorrower', 'deleteBorrower']),
    async view (id) {
      await this.$router.push({ name: 'customer-borrower-view', params: {id: id} })
    },
    async edit (id) {
      await this.$router.push({ name: 'customer-borrower-edit', params: {id: id} })
    },
    async approved (id) {
      const vm = this
      const {  $vs, approvedExternalBorrower } = vm;
      const { dialog } = $vs;
      dialog({
        type: 'confirm',
        color: 'success',
        title: 'ยืนยันการอนุมัติข้อมูล',
        text: 'คุณต้องการอนุมัติข้อมูลนี้ใช่หรือไม่',
        accept: async () => {
          await approvedExternalBorrower({
            form: {
              id: id
            },
            vm: this
          });
          await this.getBorrowersIsUnApproved();
        }
      })
    },
    async del (id) {
      const vm = this
      const {  $vs, deleteBorrower } = vm;
      const { dialog } = $vs;
      dialog({
        type: 'confirm',
        color: 'danger',
        title: vm.$t('notification.confirm-delete-title'),
        text: vm.$t('notification.confirm-delete-message'),
        accept: async () => {
          await deleteBorrower({
            form: {
              id: id
            },
            vm: this
          })
        }
      })
    },
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  },
}
</script>
